<template>
    <footer class="bg-white border-t border-gray-200">
        <div class="max-w-7xl mx-auto px-4 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
            <!-- Marque -->
            <div class="space-y-4">
                <div class="flex items-center gap-3">
                    <img class="h-9" src="https://storage.victoranw.fr/file/hGf4I3ecnS" alt="Logo Termoflow">
                    <span class="text-xl font-bold text-gray-900">Termoflow</span>
                </div>

                <p class="text-sm text-gray-600 leading-relaxed">
                    Logiciel de gestion métier pour les professionnels du chauffage et de la climatisation.
                    Interventions, conformité réglementaire, planning et pilotage en un seul outil.
                </p>
            </div>

            <!-- Produit -->
            <div>
                <h4 class="font-semibold text-gray-900 mb-4">Produit</h4>
                <ul class="space-y-2 text-sm text-gray-600">
                    <li><router-link to="/fonctionnalites" class="hover:text-orange-500">Fonctionnalités</router-link></li>
                    <li><router-link to="/interventions" class="hover:text-orange-500">Interventions</router-link></li>
                    <li><router-link to="/planification" class="hover:text-orange-500">Planification</router-link></li>
                    <li><router-link to="/cerfa" class="hover:text-orange-500">CERFA & conformité</router-link></li>
                    <li><router-link to="/application-mobile" class="hover:text-orange-500">Application mobile</router-link></li>
                    <li><router-link to="/tarifs" class="hover:text-orange-500">Tarifs</router-link></li>
                </ul>
            </div>

            <!-- Ressources -->
            <div>
                <h4 class="font-semibold text-gray-900 mb-4">Ressources</h4>
                <ul class="space-y-2 text-sm text-gray-600">
                    <li><router-link to="/contact" class="hover:text-orange-500">Contact</router-link></li>
                    <li><router-link to="/integration" class="hover:text-orange-500">Intégrations</router-link></li>
                    <li><router-link to="/exportation-donnees" class="hover:text-orange-500">Export des données</router-link></li>
                    <li><router-link to="/statistiques" class="hover:text-orange-500">Statistiques</router-link></li>
                    <li><router-link to="/portail-client" class="hover:text-orange-500">Portail client</router-link></li>
                </ul>
            </div>

            <!-- Légal -->
            <div>
                <h4 class="font-semibold text-gray-900 mb-4">Légal</h4>
                <ul class="space-y-2 text-sm text-gray-600">
                    <li><a href="https://storage.victoranw.fr/file/SJxAbw0T9t" target="_blank" class="hover:text-orange-500">Mentions légales</a></li>
                    <li><a href="https://storage.victoranw.fr/file/x3jvJaPzGU" target="_blank" class="hover:text-orange-500">Conditions générales d’utilisation</a></li>
                    <li><a href="https://storage.victoranw.fr/file/ADo4JPI8RA" target="_blank" class="hover:text-orange-500">Conditions générales de vente</a></li>
                    <li><a href="https://storage.victoranw.fr/file/n3XtdBqMSp" target="_blank" class="hover:text-orange-500">Politique de confidentialité</a></li>
                    <li><a href="https://storage.victoranw.fr/file/pJQSAKK4s2" target="_blank" class="hover:text-orange-500">Annexe RGPD</a></li>
                </ul>
            </div>
        </div>

        <!-- Bottom bar -->
        <div class="border-t border-gray-100">
            <div class="max-w-7xl mx-auto px-4 py-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
                <span>© {{ new Date().getFullYear() }} Termoflow — Tous droits réservés</span>

                <div class="flex items-center gap-4">
                    <span class="text-xs">Données hébergées en Europe • RGPD compliant</span>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {}
</script>
